import moment from 'moment'
import { SelectedSlot } from '@customTypes/Availabilities'

const validateSelectedAppointment = (appointment: SelectedSlot): boolean => {
  const now = moment()
  const selectedAppointment = moment(`${appointment.day}T${appointment.time}`)
  const diff = now.diff(selectedAppointment, 'second')
  return diff < 0
}

export default validateSelectedAppointment
